module.exports = __webpack_public_path__ + "img/undraw_book_love.4b2b3c17.png";